export default "__VITE_PUBLIC_ASSET__f2991387__"